const theme = {
  colors: {
    // "Record-label letterpress" palette: deep teal ink on warm cream paper
    // with hot burnt-orange and mustard accents — committed 1950s/60s label
    // aesthetic rather than the previous timid gray-on-beige.
    primary: '#1E3A3A',          // deep teal ink - primary text & headlines
    secondary: '#0F6B66',        // saturated label teal - buttons, accents
    accent: '#E3A92B',           // mustard - calls-to-action
    accent1: '#C34F1C',          // hot burnt orange - highlights (alias for tertiary)
    accent2: '#E3A92B',          // mustard - light accent
    accent3: '#6B7F3A',          // olive - success accent
    tertiary: '#C34F1C',         // hot burnt orange

    // Warm paper base
    background: '#F6F1E3',       // aged cream paper
    surface: '#FDFAF1',          // lighter paper for cards and sections
    surfaceAlt: '#F0E9D6',       // deeper cream - subtle contrast panels
    cardBackground: '#FDFAF1',   // card paper

    // Ink text ramp
    text: '#22312F',             // near-black teal ink
    textSecondary: '#5C6660',    // faded ink - secondary text (alias for textMuted)
    textMuted: '#5C6660',        // faded ink
    textLight: '#8A9089',        // lightest legible ink
    primaryLight: '#DCE4E0',     // pale teal wash for backgrounds

    // Utility colors
    success: '#6B7F3A',          // olive green
    warning: '#E3A92B',          // mustard
    error: '#A63D2A',            // brick red

    // Gradients kept warm and label-like
    gradients: {
      primary: 'linear-gradient(135deg, #0F6B66 0%, #1E3A3A 100%)',
      secondary: 'linear-gradient(135deg, #E3A92B 0%, #C34F1C 100%)',
      warm: 'linear-gradient(135deg, #F6F1E3 0%, #F0E9D6 100%)',
      card: 'linear-gradient(135deg, #FDFAF1 0%, #F6F1E3 100%)',
    },

    // Ink overlays
    overlay: {
      light: 'rgba(15, 107, 102, 0.08)',
      medium: 'rgba(30, 58, 58, 0.12)',
      dark: 'rgba(30, 58, 58, 0.2)',
    },

    // Border colors
    border: {
      light: '#E3DBC6',
      medium: '#C9BFa4',
      accent: '#0F6B66',
    }
  },

  fonts: {
    // Fraunces: wonky 60s-revival display serif; Libre Franklin: the Franklin
    // Gothic lineage — both era-authentic for a 1950s/60s record label.
    heading: '"Fraunces", "Playfair Display", Georgia, serif',
    subheading: '"Fraunces", "Playfair Display", Georgia, serif',
    body: '"Libre Franklin", "Lato", "Helvetica Neue", Arial, sans-serif',
    ui: '"Libre Franklin", "Lato", "Helvetica Neue", Arial, sans-serif',
    mono: '"JetBrains Mono", "Courier New", monospace',
  },
  
  fontSizes: {
    xs: '0.75rem',    // 12px
    sm: '0.875rem',   // 14px
    md: '1rem',       // 16px
    lg: '1.125rem',   // 18px
    xl: '1.25rem',    // 20px
    '2xl': '1.5rem',  // 24px
    '3xl': '1.875rem',// 30px
    '4xl': '2.25rem', // 36px
    '5xl': '3rem',    // 48px
    '6xl': '3.75rem', // 60px
  },
  
  fontWeights: {
    light: 300,
    regular: 400,
    medium: 500,
    bold: 700,
  },
  
  spacing: {
    '0': '0',
    '1': '0.25rem',    // 4px
    '2': '0.5rem',     // 8px
    '3': '0.75rem',    // 12px
    '4': '1rem',       // 16px
    '5': '1.5rem',     // 24px
    '6': '2rem',       // 32px
    '7': '2.5rem',     // 40px
    '8': '3rem',       // 48px
    '9': '4rem',       // 64px
    '10': '6rem',      // 96px
  },
  
  breakpoints: {
    xs: '320px',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
    xxl: '1400px',
  },
  
  borderRadius: {
    none: '0',
    sm: '0.25rem',    // 4px
    md: '0.5rem',     // 8px 
    lg: '1rem',       // 16px
    xl: '2rem',       // 32px
    full: '50%',
    pill: '9999px',
  },
  
  shadows: {
    // Hard offset "letterpress plate" shadows instead of soft blurs — reads
    // as printed matter, not floating material-design cards.
    none: 'none',
    sm: '2px 2px 0 rgba(30, 58, 58, 0.12)',
    md: '3px 3px 0 rgba(30, 58, 58, 0.16)',
    lg: '5px 5px 0 rgba(30, 58, 58, 0.14)',
    xl: '8px 8px 0 rgba(30, 58, 58, 0.12)',
    warm: '4px 4px 0 rgba(195, 79, 28, 0.25)',
    accent: '3px 3px 0 rgba(15, 107, 102, 0.3)',
  },
  
  transitions: {
    quick: '0.15s ease-in-out',
    default: '0.3s ease-in-out',
    slow: '0.5s ease-in-out',
    extraSlow: '1s ease-in-out',
    bounce: '0.5s cubic-bezier(0.68, -0.55, 0.27, 1.55)',
    psychedelic: '0.5s cubic-bezier(0.23, 1, 0.32, 1)',
  },
  
  // Z-index layers
  zIndex: {
    hidden: -1,
    base: 0,
    raised: 1,
    dropdown: 10,
    sticky: 100,
    overlay: 200,
    modal: 300,
    popover: 400,
    tooltip: 500,
  }
};

export default theme;
export { theme };